import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import Home from './components/Home';
import CreateBot from './components/CreateBot';
import Dashboard from './components/Dashboard';
import BotEditor from './components/BotEditor';
import ChatInterface from './components/ChatInterface';
import ScrollToTop from './components/ScrollToTop';
import Login from './components/Login';
import ProfileManagement from './components/ProfileManagement';
import Wallet from './components/Wallet';
import Plans from './components/Plans';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <ScrollToTop />
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  theme: {
                    primary: 'green',
                    secondary: 'black',
                  },
                },
              }}
            />
            <Routes>
              {/* Public routes - no authentication required */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/chat/:slug" element={<ChatInterface />} />
              <Route path="/:slug" element={<ChatInterface />} />
              
              {/* Protected routes - require authentication */}
              <Route path="/create" element={
                <ProtectedRoute>
                  <CreateBot />
                </ProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/edit/:slug" element={
                <ProtectedRoute>
                  <BotEditor />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfileManagement />
                </ProtectedRoute>
              } />
              <Route path="/wallet" element={
                <ProtectedRoute>
                  <Wallet />
                </ProtectedRoute>
              } />
              <Route path="/plans" element={
                <ProtectedRoute>
                  <Plans />
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;